import { useDropzone } from "react-dropzone";
import { useState, useCallback } from "react";
import "./style.scss";

const CustomDropZone = ({
  acceptingFormates,
  onDropItems,
  dropZoneClass,
  rootProps,
  dropZoneProps,
  onClickDropZone,
  children,
  inputRef,
  isShowTextOnDrag = false,
  handleDragLeave = () => {},
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: acceptingFormates,
    onDrop: onDropItems,
    multiple: true,
    onDragLeave: handleDragLeave,
    ...dropZoneProps,
  });

  return (
    <div
      {...getRootProps({ className: dropZoneClass, ...rootProps })}
      onClick={onClickDropZone}
    >
      <input {...getInputProps()} ref={inputRef} webkitdirectory="true" />
      {isShowTextOnDrag &&
        (isDragActive ? (
          <span
            style={{ width: "fix-content", zIndex: 4 }}
            className="drop_text"
          >
            Drop your file here
          </span>
        ) : (
          ""
        ))}
      {children}
    </div>
  );
};

export default CustomDropZone;
